import React from 'react';
import { ControlGroup } from './ControlGroup';

interface SmartInputProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  onChange: (val: number) => void;
  darkMode: boolean;
  tooltip?: string;
  settingKey?: string;
  disabled?: boolean;
  disabledMessage?: string;
  modes?: string[];
  fullWidth?: boolean;
}

export const SmartInput: React.FC<SmartInputProps> = ({ 
  label, value, min, max, step = 1, onChange, darkMode, tooltip, settingKey, disabled, disabledMessage, modes, fullWidth 
}) => (
  <ControlGroup 
    label={label} 
    tooltip={tooltip} 
    settingKey={settingKey}
    disabled={disabled} 
    disabledMessage={disabledMessage} 
    modes={modes}
    darkMode={darkMode}
  >
    <div className="flex gap-4 items-center w-full min-w-0">
      <div className="relative flex-1 flex items-center h-4">
          <input 
            type="range" 
            min={min} 
            max={max} 
            step={step} 
            value={value} 
            onChange={e => onChange(parseFloat(e.target.value))} 
            className={`
                w-full h-1.5 rounded-full appearance-none cursor-pointer transition-all
                ${darkMode ? 'bg-white/10 accent-cyan-400' : 'bg-zinc-200 accent-cyan-600'}
                focus:outline-none hover:opacity-80
            `}
          />
      </div>
      <input 
        type="number" 
        min={min}
        max={max}
        step={step}
        value={value} 
        onChange={e => {
          const val = parseFloat(e.target.value);
          if (!isNaN(val)) onChange(val);
        }}
        className={`
            w-[72px] h-9 px-2 text-[12px] font-mono font-bold text-center border-2 rounded-xl outline-none transition-all flex-shrink-0 
            ${darkMode 
              ? 'bg-black/40 border-white/5 text-white focus:border-cyan-400/30' 
              : 'bg-white border-zinc-100 text-zinc-950 focus:border-cyan-600/30 focus:shadow-sm'}
        `}
      />
    </div>
  </ControlGroup>
);
